document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-bundle-section-link]');
  if (!link) return;
  const section = Array.from(document.querySelectorAll('[data-bundle-section-product]')).find(
    (section) => section.dataset.bundleSectionProduct === link.dataset.bundleSectionLink
  );
  if (!section) return;
  event.preventDefault();
  section.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
});
document.addEventListener('change', (event) => {
  const option = event.target.closest('[data-bundle-section-variant]');
  if (!option) return;
  const section = option.closest('[data-bundle-section-product]');
  const form = option.closest('form');
  const input = form.querySelector('.product-variant-id');
  const available = option.dataset.available === 'true';
  input.value = option.value;
  input.disabled = !available;
  const submit = form.querySelector('[name="add"]');
  submit.disabled = !available;
  const label = submit.querySelector('[data-bundle-section-submit-label]');
  label.textContent = available ? label.dataset.availableLabel : label.dataset.soldOutLabel;
  section.querySelectorAll('[data-bundle-section-price]').forEach((price) => {
    price.hidden = price.dataset.bundleSectionPrice !== option.value;
  });
  const image = section.querySelector('.product-bundle__image-frame > img');
  if (image && option.dataset.image) {
    image.src = option.dataset.image;
    image.removeAttribute('srcset');
  }
});
